<template>
    <div class="page-table mainDiv" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">
            Demir Fiyatları
        </div>
        <el-row :gutter="10">
            <el-col :lg="16" :md="16" :sm="24" :xs="24">
                <div class="page-header card-base card-shadow--medium animated fadeInUp">
                    <div>
                        <el-radio-group size="mini" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9"
                                        text-color="gray">
                            <el-radio-button label="1">
                                <i class="mdi mdi-bullhorn mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                                <transition
                                        name="slide-fade"><label v-if="selectIcon==='1'">Aktif Demirler</label>
                                </transition>
                            </el-radio-button>
                            <el-radio-button label="0">
                                <i class="mdi mdi-bullhorn mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                                <transition
                                        name="slide-fade"><label v-if="selectIcon==='0'">Pasif Demirler</label>
                                </transition>
                            </el-radio-button>
                        </el-radio-group>
                    </div>
                    <el-table
                            border
                            stripe
                            :data="demirList"
                            style="width: 100%">
                        <el-table-column
                                label="Sıra"
                                type="index"
                                width="50">
                        </el-table-column>
                        <el-table-column
                                prop="tarih"
                                label="Tarih"
                                width="auto">
                        </el-table-column>
                        <el-table-column
                                prop="sehir"
                                label="Şehir"
                                width="auto">
                            <template slot-scope="scope">
                                <span v-if="scope.row.sehir === '1'"> Sivas </span>
                                <span v-if="scope.row.sehir === '2'"> Payas </span>
                                <span v-if="scope.row.sehir === '3'"> Karabük </span>
                                <span v-if="scope.row.sehir === '4'"> İstanbul </span>
                                <span v-if="scope.row.sehir === '5'"> Samsun </span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="q8mm"
                                label="Q8mm"
                                width="auto">
                        </el-table-column>
                        <el-table-column
                                prop="q10mm"
                                label="Q10mm"
                                width="auto">
                        </el-table-column>
                        <el-table-column
                                prop="q1232mm"
                                label="Q12mm-Q32mm"
                                width="auto">
                        </el-table-column>
                        <el-table-column
                                label="İşlem"
                                align="right"
                                width="auto">
                            <template slot-scope="scope">
                                <el-tooltip :content='$t("src.views.apps.haberler.kategori.liste.duzenle")'
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-on:click="selectionIndex=scope.$index; selection=scope.row; updateStart(scope.row); "
                                            type="text"
                                            class="buttonEdit"
                                            icon="el-icon-edit">
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip :content='$t("src.views.apps.haberler.kategori.liste.sil")'
                                            :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-if="selectIcon==='1'"
                                            v-on:click="dialogVisible = true; selection=scope.row; selectionIndex=scope.$index"
                                            type="text"
                                            class="buttonDel"
                                            icon="mdi mdi-delete mdi-24px">
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip :content='$t("src.views.apps.sayfa.liste.yayindanKaldir")' :open-delay="500"
                                            placement="bottom">
                                    <el-button
                                            v-if="selectIcon==='0' "
                                            @click="demirDurumChange(scope.row,scope.$index,demirList,1)"
                                            type="text"
                                            icon="mdi mdi-play mdi-24px">
                                    </el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                            background
                            layout="sizes,prev, pager, next, jumper, total"
                            :total="total"
                            @size-change="handleSizeChange"
                            @current-change="pageChange"
                            :page-sizes="[10, 20, 50, 100]"
                            :current-page.sync="page"
                            :next-click.sync="page"
                            :prev-click.sync="page"
                            @next-click="pageChange"
                            @prev-click="pageChange">
                    </el-pagination>
                </div>
            </el-col>
            <el-col :lg="8" :md="8" :sm="24" :xs="24">
                <div class="card-base card-shadow--medium demo-box bg-white animated fadeInUp">
                    <el-form status-icon :model="demirForm" :rules="rulesDemir" ref="demirForm"
                             class="demo-ruleForm" label-position="top">

                        <div v-if="ekleme">
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item label='Tarih' prop="tarih">
                                        <el-date-picker
                                                v-model="demirForm.tarih"
                                                type="date"
                                                :picker-options="dateRangeOptions"
                                                format="yyyy-MM-dd"
                                                value-format="yyyy-MM-dd"
                                                placeholder="Demir Tarihi">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-divider content-position="left">Sivas</el-divider>
                                <el-col :lg="8" :md="8" :sm="8" :xs="8" class="col-p">
                                    <el-form-item
                                            label='Q8mm :'>
                                        <el-input
                                                v-model="demirForm.demir[0].q8mm"
                                                placeholder='Q8mm Fiyatı'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="8" :md="8" :sm="8" :xs="8" class="col-p">
                                    <el-form-item
                                            label='Q10mm :'>
                                        <el-input
                                                v-model="demirForm.demir[0].q10mm"
                                                placeholder='Q8mm Fiyatı'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="8" :md="8" :sm="8" :xs="8" class="col-p">
                                    <el-form-item
                                            label='Q12mm - Q32mm :'>
                                        <el-input
                                                v-model="demirForm.demir[0].q1232mm"
                                                placeholder='Q8mm Fiyatı'></el-input>
                                    </el-form-item>
                                </el-col>

                            </el-row>
                            <el-row>
                                <el-divider content-position="left">Payas</el-divider>
                                <el-col :lg="8" :md="8" :sm="8" :xs="8" class="col-p">
                                    <el-form-item
                                            label='Q8mm :'>
                                        <el-input
                                                v-model="demirForm.demir[1].q8mm"
                                                placeholder='Q8mm Fiyatı'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="8" :md="8" :sm="8" :xs="8" class="col-p">
                                    <el-form-item
                                            label='Q10mm :'>
                                        <el-input
                                                v-model="demirForm.demir[1].q10mm"
                                                placeholder='Q8mm Fiyatı'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="8" :md="8" :sm="8" :xs="8" class="col-p">
                                    <el-form-item
                                            label='Q12mm - Q32mm :'>
                                        <el-input
                                                v-model="demirForm.demir[1].q1232mm"
                                                placeholder='Q8mm Fiyatı'></el-input>
                                    </el-form-item>
                                </el-col>

                            </el-row>
                            <el-row>
                                <el-divider content-position="left">Karabük</el-divider>
                                <el-col :lg="8" :md="8" :sm="8" :xs="8" class="col-p">
                                    <el-form-item
                                            label='Q8mm :'>
                                        <el-input
                                                v-model="demirForm.demir[2].q8mm"
                                                placeholder='Q8mm Fiyatı'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="8" :md="8" :sm="8" :xs="8" class="col-p">
                                    <el-form-item
                                            label='Q10mm :'>
                                        <el-input
                                                v-model="demirForm.demir[2].q10mm"
                                                placeholder='Q8mm Fiyatı'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="8" :md="8" :sm="8" :xs="8" class="col-p">
                                    <el-form-item
                                            label='Q12mm - Q32mm :'>
                                        <el-input
                                                v-model="demirForm.demir[2].q1232mm"
                                                placeholder='Q8mm Fiyatı'></el-input>
                                    </el-form-item>
                                </el-col>

                            </el-row>
                            <el-row>
                                <el-divider content-position="left">İstanbul</el-divider>
                                <el-col :lg="8" :md="8" :sm="8" :xs="8" class="col-p">
                                    <el-form-item
                                            label='Q8mm :'>
                                        <el-input
                                                v-model="demirForm.demir[3].q8mm"
                                                placeholder='Q8mm Fiyatı'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="8" :md="8" :sm="8" :xs="8" class="col-p">
                                    <el-form-item
                                            label='Q10mm :'>
                                        <el-input
                                                v-model="demirForm.demir[3].q10mm"
                                                placeholder='Q8mm Fiyatı'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="8" :md="8" :sm="8" :xs="8" class="col-p">
                                    <el-form-item
                                            label='Q12mm - Q32mm :'>
                                        <el-input
                                                v-model="demirForm.demir[3].q1232mm"
                                                placeholder='Q8mm Fiyatı'></el-input>
                                    </el-form-item>
                                </el-col>

                            </el-row>
                            <el-row>
                                <el-divider content-position="left">Samsun</el-divider>
                                <el-col :lg="8" :md="8" :sm="8" :xs="8" class="col-p">
                                    <el-form-item
                                            label='Q8mm :'>
                                        <el-input
                                                v-model="demirForm.demir[4].q8mm"
                                                placeholder='Q8mm Fiyatı'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="8" :md="8" :sm="8" :xs="8" class="col-p">
                                    <el-form-item
                                            label='Q10mm :'>
                                        <el-input
                                                v-model="demirForm.demir[4].q10mm"
                                                placeholder='Q8mm Fiyatı'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="8" :md="8" :sm="8" :xs="8" class="col-p">
                                    <el-form-item
                                            label='Q12mm - Q32mm :'>
                                        <el-input
                                                v-model="demirForm.demir[4].q1232mm"
                                                placeholder='Q8mm Fiyatı'></el-input>
                                    </el-form-item>
                                </el-col>

                            </el-row>
                        </div>
                        <div v-if="guncelleme">
                            <el-row>
                                <el-divider v-if="guncelSehir === '1'" content-position="left">Sivas</el-divider>
                                <el-divider v-if="guncelSehir === '2'" content-position="left">Payas</el-divider>
                                <el-divider v-if="guncelSehir === '3'" content-position="left">Karabük</el-divider>
                                <el-divider v-if="guncelSehir === '4'" content-position="left">İstanbul</el-divider>
                                <el-divider v-if="guncelSehir === '5'" content-position="left">Samsun</el-divider>

                                <el-col :lg="8" :md="8" :sm="8" :xs="8" class="col-p">
                                    <el-form-item
                                            label='Q8mm :'>
                                        <el-input
                                                v-model="demirForm.demirG.q8mm"
                                                placeholder='Q8mm Fiyatı'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="8" :md="8" :sm="8" :xs="8" class="col-p">
                                    <el-form-item
                                            label='Q10mm :'>
                                        <el-input
                                                v-model="demirForm.demirG.q10mm"
                                                placeholder='Q8mm Fiyatı'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="8" :md="8" :sm="8" :xs="8" class="col-p">
                                    <el-form-item
                                            label='Q12mm - Q32mm :'>
                                        <el-input
                                                v-model="demirForm.demirG.q1232mm"
                                                placeholder='Q8mm Fiyatı'></el-input>
                                    </el-form-item>
                                </el-col>

                            </el-row>
                        </div>
                        <el-row class="col-p">
                            <el-form-item>
                                <el-button v-if="btnVisible" size="small" v-on:click="demirTanimlama('demirForm')"
                                           type="primary">
                                    Demir Tanımla
                                </el-button>
                                <el-button v-else size="small" v-on:click="demirGuncelleme('demirForm')" type="primary">
                                    Demir Güncelle
                                </el-button>
                                <el-button v-if="!btnVisible" size="small" v-on:click="vazgec('demirForm')">
                                    Vazgeç
                                </el-button>
                            </el-form-item>
                        </el-row>
                    </el-form>
                </div>
            </el-col>
        </el-row>
        <el-dialog
                :title='$t("src.views.apps.haberler.liste.uyari")'
                :visible.sync="dialogVisible"
                width="30%"
                center>
            <span>"{{selection["baslik"]}}" {{$t('src.views.apps.haberler.kategori.tanimlama.sil')}}</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="demirDurumChange(selection,selectionIndex,demirList,0), dialogVisible = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="dialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>
    import demirService from '../../../WSProvider/DemirService'
    import seoService from '../../../WSProvider/SeoService'
    import notification from '../../../notification'
    import JQuery from 'jquery';

    let $ = JQuery;
    let base64 = require('base64_js');
    let userData5B = "";
    export default {
        name: "Demirler",
        mounted() {
            this.getDemirList();
        },
        data() {
            return {
                page: 0,
                sizes: 10,
                postPage: 0,
                total: null,
                selectIcon: '1',
                radio: '1',
                demirList: [],
                dateRangeOptions: {
                    firstDayOfWeek: 1,
                },
                path: demirService.path,
                updateKodu: '',
                btnVisible: true,
                selection: '',
                selectionIndex: '',
                ekleme: true,
                guncelleme: false,
                dialogVisible: false,
                guncelSehir: "",
                duzenleBtnVisible: true,
                VisibleA: false,
                linkVisible: false,
                linkChange: true,
                disabled: false,
                demirForm: {
                    tarih: '',
                    demirG:
                        {
                            sehir: '',
                            q8mm: '',
                            q10mm: '',
                            q1232mm: '',
                        },
                    demir: [
                        {
                            sehir: 1,
                            q8mm: '',
                            q10mm: '',
                            q1232mm: '',
                        },
                        {
                            sehir: 2,
                            q8mm: '',
                            q10mm: '',
                            q1232mm: '',
                        },
                        {
                            sehir: 3,
                            q8mm: '',
                            q10mm: '',
                            q1232mm: '',
                        },
                        {
                            sehir: 4,
                            q8mm: '',
                            q10mm: '',
                            q1232mm: '',
                        },
                        {
                            sehir: 5,
                            q8mm: '',
                            q10mm: '',
                            q1232mm: '',
                        }],

                },
                rulesDemir: {
                    tarih: [{
                        required: true,
                        message: "Lütfen Tarih Seçiniz",
                        trigger: 'blur'
                    }],
                },
            }
        },
        methods: {
            handleSizeChange(val) {
                this.sizes = val;
                this.getDemirList();
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getDemirList();
            },
            handleChange(event) {
                this.selectIcon = event;
                this.getDemirList();
            },
            getDemirList() {
                let self = this;
                demirService.demirList(this.postPage, this.sizes, this.selectIcon).then((response) => {
                    if (response.status === 200) {
                        this.demirList = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            updateStart(scope) {
                console.log(scope)
                this.ekleme = false;
                this.guncelleme = true;
                this.guncelSehir = scope.sehir;
                this.demirForm.demirG.sehir = scope.sehir;
                this.demirForm.demirG.q8mm = scope.q8mm;
                this.demirForm.demirG.q10mm = scope.q10mm;
                this.demirForm.demirG.q1232mm = scope.q1232mm;
                this.updateKodu = scope.dfiyatId;
                this.btnVisible = false;
            },
            vazgec(formName) {
                this.$refs[formName].resetFields();
                this.btnVisible = true;
                this.ekleme = true;
                this.guncelleme = false;
            },
            demirTanimlama(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {

                        demirService.demirTanimlama(this.demirForm.tarih, this.demirForm.demir).then((response) => {
                            if (response.status === 200) {
                                this.demirList.push(response.data);
                                notification.Status('success', this, 'Demir başarıyla eklendi.');
                                this.$refs[formName].resetFields();
                                this.demirForm.link = '';
                                this.linkVisible = false;
                                this.VisibleA = false;
                            } else if (response.status === 230) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir kategori zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            demirGuncelleme(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        demirService.demirGuncelle(this.updateKodu, this.demirForm.demirG.q8mm, this.demirForm.demirG.q10mm, this.demirForm.demirG.q1232mm).then((response) => {
                            if (response.status === 200) {
                                this.demirList.splice(this.selectionIndex, 1);
                                this.demirList.splice(this.selectionIndex, 0, {
                                    q8mm: response.data.q8mm,
                                    q10mm: response.data.q10mm,
                                    q1232mm: response.data.q1232mm,
                                    tarih: response.data.tarih2,
                                    sehir: response.data.sehir,
                                    dfiyatId: response.data.dfiyatId
                                });
                                notification.Status('success', this, 'Demir başarıyla güncellendi...');
                                this.$refs[formName].resetFields();
                                this.btnVisible = true;
                                this.ekleme = true;
                                this.guncelleme = false;
                            } else if (response.status === 200) {
                                notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir kategori zaten mevcut');
                            } else {
                                notification.Status(response.status, this)
                            }
                        });
                    }
                })
            },
            demirDurumChange(selection, index, list, durum) {
                demirService.demirDurumGuncelle(selection.dfiyatId, durum).then((response) => {
                    if (response.status === 200) {
                        notification.Status('success', this, 'Demir durumu değiştirildi.');
                        list.splice(index, 1);
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
        }
    }

</script>


<style scoped>
    .el-pagination {
        margin-top: 20px;
        float: right;
    }
</style>